import { render, staticRenderFns } from "./SearchInitialState.vue?vue&type=template&id=bd8e652c&scoped=true"
import script from "./SearchInitialState.vue?vue&type=script&lang=js"
export * from "./SearchInitialState.vue?vue&type=script&lang=js"
import style0 from "./SearchInitialState.vue?vue&type=style&index=0&id=bd8e652c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8e652c",
  null
  
)

export default component.exports